import React from "react";
import { makeStyles } from "@mui/styles";
import PrimaryButton from "../PrimaryButton";

const secondaryButtonStyles = makeStyles((theme) => ({
    button: {
        "&:disabled": {
            color: theme.palette.secondary.light,
            background: theme.palette.secondary.superLight,
            borderColor: theme.palette.border.primary,

            "& svg": {
                color: theme.palette.secondary.bark,
            },
        },
    },
    text: {
        width: 150,
        height: 55,
        border: `1px solid ${theme.palette.primary.superDark}!important`,
        borderRadius: theme.shape.borderRadius,
        padding: "8px 10px",
        lineHeight: 1,
        fontSize: 12,

        "& svg": {
            width: 18,
            height: 18,
            marginRight: 5,
        },
    },
    textSecondary: {
        color: theme.palette.primary.main,
        background: "#fff",

        "&:hover, &:active": {
            boxShadow: `inset 0px 0px 2px ${theme.palette.primary.superDark}`,
            background: "#fff",
        },
    },
    textSizeSmall: {
        fontSize: theme.typography.button.fontSize,
    },
    textSizeLarge: {
        fontSize: theme.typography.button.fontSize,
    },
    sizeSmall: {
        width: 145,
        height: 45,
        padding: 3,
    },
    sizeLarge: {
        width: 280,
        height: 64,
    },
    sizeXSmall: {
        width: 75,
        height: 35,
    },
}));

const SecondaryButton = (props) => {
    const classes = secondaryButtonStyles();

    return <PrimaryButton {...props} color={"secondary"} classes={classes} />;
};

export default SecondaryButton;
